import { makeAutoObservable } from 'mobx';

class MessageStore {
  message = null;

  constructor() {
    makeAutoObservable(this);
  }

  setMessage(message) {
    this.message = message;
  }

  success(content) {
    this.message?.success(content);
  }

  error(content) {
    this.message?.error(content);
  }

  info(content) {
    this.message?.info(content);
  }

  warning(content) {
    this.message?.warning(content);
  }
}

export const messageStore = new MessageStore();
